export function line(_ctx) {
    return {
        styles: {
            main: { bg_opa: 0, line_color: '#ffffff', line_width: 1, line_rounded: false },
        },
    };
}
